import React, { useEffect, useState } from "react";
import useFetch from "../../Controllers/useFetch";
import TablesClean from "./TablesClean";

import { Card, CardBody } from "reactstrap";
import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { add_facts_id } from "../../Redux/actions";
import { gql, useMutation, useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const GET_PLANTS_LIST = gql`
  query ($date: Date,$time_offset:Int!) {
    GetPlants(time_offset: $time_offset, date: $date) {
      plants {
        plant_id
        fact_index
        fact_name
        fact_address
        prod_index
        
      }
    }
  }
`;
// plant_event {
//   event_time
//   Event_Description {
//     title
//     content
//     event_code
//   }
//   event_code
// }
const Facts_page = () => {
  const [dateHOC, setDateHOC] = useState(dayjs(new Date(), { jalali: true }));
  const [data, setData] = useState([]);
  // const { data, loading } = useFetch(
  //   "Fact_list",
  //   "post",
  //   `/factories_list`,
  //   0,
  //   {
  //     headers: { Authorization: "12345678" },
  //     params: { email: window.localStorage.getItem("email") },
  //   }
  // );

  const { loading, error } = useQuery(GET_PLANTS_LIST, {
    variables: { date: dateHOC,time_offset:new Date().getTimezoneOffset() },
    onCompleted: (res) => {
      // console.log(res.GetPlants.plants);
      if (res.GetPlants) {
        const FactIDSList = res.GetPlants.plants.map((item) => item.plant_id);
        dispatch(add_facts_id(FactIDSList));
        // console.log(FactIDSList, "is array of facts ids");
        ///// Facts Ids Validation List//////
        window.localStorage.setItem("f_i_v", JSON.stringify(FactIDSList));
        /////////////////////////////////////
        setData(res.GetPlants.plants);
        if (loading === false && show === false) {
          setShow(true);
        }
      }
    },
    onError: (err) => {
      const { message } = err;
      // console.log(err);
      toast.error(message ? message : "مشکلی در دریافت اطلاعات رخ داده است!");
      if (loading === false && show === false) {
        setShow(true);
      }
    },
  });
  // if (error)
  //   console.log(
  //     error.graphQLErrors,
  //     error.cause,
  //     error.clientErrors,
  //     error.extraInfo,
  //     error.networkError,

  //   );

  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  if ((error && !show) || (error && loading)) {
    return (
      <Card>
        <CardBody className="text-center">
          <Spin spinning={true} delay={500} tip="Loading..."></Spin>
        </CardBody>
      </Card>
    );
  } else {
    // console.log(loading, data);

    if (show === true) {
      return <TablesClean setdata={data} />;
    } else {
      return (
        <Card>
          <CardBody className="text-center">
            <Spin spinning={true} delay={500} tip="Loading..."></Spin>
          </CardBody>
        </Card>
      );
    }
  }
};

export default Facts_page;
